import { Link } from "react-router-dom";
import styles from "./Banner.module.css";
import ArrowLeft from "../../../../assets/icons/ArrowLeft.svg";
import Person from "../../../../assets/icons/person.png";
import { Modal } from "@react-solutions-ui/findmore-ui";
import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";

export type ModalInfo = {
  type: "confirm" | "info";
  title: string;
  content: ReactNode;
  action: () => void;
  closeAction: () => void;
  confirmActionLabel: string;
  closeActionLabel: string;
  isSending?: boolean;
};

export default function Banner({
  evaluatorType,
  autoEvaluation,
  evaluatedName,
}: {
  evaluatorType: string;
  autoEvaluation: boolean;
  evaluatedName: string;
}) {
  const [modalInfo, setModalInfo] = useState<ModalInfo | null>(null);
  const navigate = useNavigate();

  const handleBack = () => {
    setModalInfo({
      type: "confirm",
      title:
        autoEvaluation === true
          ? "Sair da autoavaliação"
          : "Sair da avaliação de " + evaluatedName + "?",
      content: (
        <p>
          Podes continuar mais tarde, o teu progresso foi guardado
          automaticamente.
        </p>
      ),
      action: () => {
        navigate("/home");
      },
      closeAction: () => setModalInfo(null),
      confirmActionLabel: "Sim, sair",
      closeActionLabel: "Não, continuar",
    });
  };

  return (
    <div>
      <div className={styles.background}>
        <div className={`${styles.contentContainer} page-container`}>
          <div className={styles.container}>
            {evaluatorType !== "Client" && (
              <button className={styles.backLink} onClick={handleBack}>
                <img src={ArrowLeft} alt="Arrow left" />
                VOLTAR PARA O INÍCIO
              </button>
            )}

            <div className={styles.content}>
              <h1 className={styles.title}>
                {autoEvaluation === true
                  ? "Autoavaliação"
                  : evaluatorType === "Client"
                  ? `Evaluate ${evaluatedName}`
                  : `Avaliação de ${evaluatedName}`}
              </h1>

              <div className={styles.info}>
                <p className={styles.infoMainText}>
                  {autoEvaluation === true
                    ? "Completa todos os passos para finalizares a tua autoavaliação"
                    : evaluatorType === "Client"
                    ? `Please share your feedback on ${evaluatedName} performance and collaboration`
                    : `Esta avaliação tem como objetivo recolher o teu feedback sobre a colaboração e o relacionamento profissional`}
                </p>
                <p className={styles.infoSecondaryText}>
                  {autoEvaluation === true
                    ? "Irás responder a diferentes secções sobre as tuas competências, objetivos e principais pontos de melhoria."
                    : evaluatorType === "Client"
                    ? `Indicate whether her work met or exceeded your expectations, considering quality, communication, and results.`
                    : `Sê honesto e construtivo, destacando os pontos fortes e as oportunidades de melhoria.`}
                </p>
              </div>
            </div>
          </div>

          {autoEvaluation === true && (
            <img
              src={Person}
              alt="Person Illustration"
              className={styles.illustration}
            />
          )}
        </div>
      </div>
      {modalInfo && (
        <Modal
          title={modalInfo?.title!}
          type={modalInfo?.type!}
          onConfirmAction={modalInfo?.action!}
          onCloseModal={modalInfo?.closeAction!}
          confirmActionLabel={modalInfo?.confirmActionLabel!}
          closeModalLabel={modalInfo?.closeActionLabel!}
          isSending={modalInfo?.isSending!}
        >
          {modalInfo?.content!}
        </Modal>
      )}
    </div>
  );
}
